import React from 'react'

import { Button } from '@/components/ui/button'
import { useAuth } from '@/hooks/useAuth'
import { EMAIL_ADDRESSES } from '@/lib/constants'

const RefreshPagePrompt: React.FC = () => {
  const { signOut, isAuthenticated } = useAuth()

  return (
    <>
      <p className="mb-4">
        Please refresh this page to try again.
        {isAuthenticated && (
          <>
            {' '}
            You can also try{' '}
            <Button
              variant="link"
              size="sm"
              className="h-auto p-0 align-baseline"
              onClick={() => signOut()}
            >
              logging out and back in
            </Button>
            , which sometimes resolves authentication related issues.
          </>
        )}
      </p>
      <p className="mb-4">
        If the problem persists, you can try again later or contact us at{' '}
        <a href={`mailto:${EMAIL_ADDRESSES.rqHello}?subject=Website error`}>
          {EMAIL_ADDRESSES.rqHello}
        </a>{' '}
        and we can help out!
      </p>
    </>
  )
}

export default RefreshPagePrompt
